// extracted by mini-css-extract-plugin
export var oKeyVisual = "keyVisual-module--o-keyVisual--1VEeW";
export var oKeyVisual__outer = "keyVisual-module--o-keyVisual__outer--GhEaB";
export var pleaseScroll = "keyVisual-module--pleaseScroll--dyG6P";
export var line = "keyVisual-module--line--2V059";
export var arrow = "keyVisual-module--arrow--1lGkA";
export var arrowNarrow = "keyVisual-module--arrowNarrow--1-yMM";
export var lContent__inner = "keyVisual-module--l-content__inner--3YRLB";
export var oKeyVisual__message = "keyVisual-module--o-keyVisual__message--39cbt";
export var oKeyVisual__image = "keyVisual-module--o-keyVisual__image--2CQ3Q";
export var oButton = "keyVisual-module--o-button--160A-";
export var visible = "keyVisual-module--visible--1uUBx";
export var yellowRectangle = "keyVisual-module--yellowRectangle--232E_";
export var yellowRectangleNarrow = "keyVisual-module--yellowRectangleNarrow--1WqEN";
export var turquoiseRectangle = "keyVisual-module--turquoiseRectangle--fb94x";
export var texts = "keyVisual-module--texts--10ZkU";
export var textsNarrow = "keyVisual-module--textsNarrow--1M_jl";
export var keyVisual = "keyVisual-module--keyVisual--15gQX";
export var standby = "keyVisual-module--standby--EnKWl";